import { FormLayerObject, PageLayerObject } from "@models/DataLayerR3.model";
import { get } from "lodash";

export class SSPageDataLayerObject extends PageLayerObject {}

export class SSAcquisitionDataLayerObject {
  customer = {
    DOB: "",
    age: "",
    gender: "",
    marketingOptIn: "",
    servicingMode: "",
  };
  product = {
    policyID: "",
    riderpolicyID: "",
    prodID: "",
    prodName: "",
  };
  insurance = {
    premium: "",
    promoCode: "",
    discount: "",
    coverType: "",
    previousInsurer: "",
    paymentType: "",
  };

  constructor(data: any) {
    this.customer = get(data, "customer", {
      DOB: "",
      age: "",
      gender: "",
      marketingOptIn: "",
      servicingMode: "",
    });

    this.product = get(data, "product", {
      policyID: "",
      riderpolicyID: "",
      prodID: "",
      prodName: "",
    });

    this.insurance = get(data, "insurance", {
      premium: "",
      promoCode: "",
      discount: "",
      coverType: "",
      previousInsurer: "",
      paymentType: "",
    });
  }
}

export class SSFormDataLayerObject extends FormLayerObject {}

export class SSDataLayer {
  public page: SSPageDataLayerObject;
  public acquisition: SSAcquisitionDataLayerObject;
  public form: SSFormDataLayerObject;

  constructor(initialData: any) {
    this.page = get(initialData, "page", {});
    this.acquisition = get(initialData, "acquisition", {});
    this.form = get(initialData, "form", {});
  }
}
